var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-plus",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.984 12.535a9 9 0 1 0 -8.468 8.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16v6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7v5l3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockPlus);
export default __webpack_public_path__ + "static/media/clock-plus.2576423a.svg";
export { ForwardRef as ReactComponent };